export default __webpack_public_path__ + "static/media/firebase-pinggo-logo.9cd2ea71.png";